import PropTypes from 'prop-types';
import React from 'react';
import { ButtonWrapper } from 'src/components';
import { PanelLoading } from 'src/components/loading';
import { Button, Modal, Panel } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import { useHibana } from 'src/context/HibanaContext';

export default function ConfirmationModal(props) {
  const {
    open,
    title,
    isPending,
    children = null,
    confirming,
    content = children,
    onConfirm,
    confirmVariant = 'primary',
    cancelVariant = 'secondary',
    onCancel,
    confirmVerb = 'Confirm',
    cancelVerb = 'Cancel',
    showCloseButton,
    disabled = false
  } = props;

  const renderContent = () => {
    return (
      <>
        <Panel.LEGACY.Section>{content}</Panel.LEGACY.Section>
        <Panel.LEGACY.Section>
          <ButtonWrapper>
            <Button
              variant={confirmVariant}
              disabled={confirming}
              name="confirmation-modal-confirm-button"
              onClick={onConfirm}
            >
              <TranslatableText>{confirmVerb}</TranslatableText>
            </Button>
            <Button variant={cancelVariant} onClick={onCancel} disabled={disabled}>
              <TranslatableText>{cancelVerb}</TranslatableText>
            </Button>
          </ButtonWrapper>
        </Panel.LEGACY.Section>
      </>
    );
  };

  const [state] = useHibana();
  const { isHibanaEnabled } = state;

  return (
    <Modal.LEGACY
      open={open}
      onClose={onCancel}
      showCloseButton={isHibanaEnabled || showCloseButton}
      title={title}
    >
      {isPending ? (
        <PanelLoading minHeight="200px" title={title} />
      ) : (
        <Panel.LEGACY title={title}>{renderContent()}</Panel.LEGACY>
      )}
    </Modal.LEGACY>
  );
}

ConfirmationModal.propTypes = {
  confirming: PropTypes.bool,
  open: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.node,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmVerb: PropTypes.string,
  confirmVariant: PropTypes.string,
  cancelVerb: PropTypes.string,
  cancelVariant: PropTypes.string,
  showCloseButton: PropTypes.bool,
  isPending: PropTypes.bool,
  disabled: PropTypes.bool
};
